import React, { FunctionComponent, JSX } from "react";
import Icon from "@ant-design/icons";
import { IIcon } from "./icons-interfaces";

const QuestionSvg = () => (
  <svg fill="currentColor" width="1em" height="1em" viewBox="0 0 48 48">
    <path d="M38.92,4.22H10.08c-3.23,0-5.86,2.63-5.86,5.86v28.84c0,3.23,2.63,5.86,5.86,5.86h28.84c3.23,0,5.86-2.63,5.86-5.86V10.08c0-3.23-2.63-5.86-5.86-5.86ZM40.78,38.92c0,1.03-.83,1.86-1.86,1.86H10.08c-1.03,0-1.86-.83-1.86-1.86V10.08c0-1.03.83-1.86,1.86-1.86h28.84c1.03,0,1.86.83,1.86,1.86v28.84Z" />
    <path d="M23.76,32.59c-1.27,0-2.31,1.03-2.31,2.31s1.03,2.31,2.31,2.31,2.31-1.03,2.31-2.31-1.03-2.31-2.31Z" />
    <path d="M29.96,13.36c-4.04-3.44-8.94-.58-10.97,1.41-.79.77-.8,2.03-.03,2.82.77.79,2.03.81,2.83.04.13-.13,3.32-3.16,5.58-1.22,1.02.87.98,1.64.96,1.89-.08,1.25-1.25,2.76-3.06,3.94-3.02,1.97-3.54,3.34-3.51,5.47,0,.18,0,.38,0,.59-.04,1.1.82,2.03,1.92,2.08.03,0,.05,0,.08,0,1.07,0,1.96-.85,2-1.92.01-.29,0-.55,0-.79,0-.79-.01-.95,1.7-2.07,2.93-1.91,4.7-4.47,4.86-7.04.09-1.38-.25-3.39-2.36-5.19Z" />
  </svg>
);

const QuestionIcon: FunctionComponent<IIcon> = (props): JSX.Element => (
  <Icon className={props.className} component={QuestionSvg} />
);

export default QuestionIcon;
